/* eslint-disable quotes */
/* eslint-disable react/react-in-jsx-scope */
/* eslint-disable react-hooks/exhaustive-deps */
import { useNavigation } from '@react-navigation/native';
import { useEffect } from 'react';
import navigationService from '../services/NavigationService';
import { errorHandler, getCompanyInfo, getInfo, getPaymentGateways, getProfile } from '../services/Utils';
import * as storage from '../services/storage';
import { useSelector } from 'react-redux';

/**
 * Higher-Order Component that checks authentication state and loads user data
 * Fetches app info, profile, and payment methods if user is authenticated
 * @param {React.Component} Component - Component to wrap with auth check
 * @returns {React.Component} Wrapped component with auth functionality
 */
const withAuthCheck = (Component) => {
    return (props) => {
        const status = useSelector((state) => state.info?.status);
        const customer = useSelector((state) => state.customer?.customer);
        const navigation = useNavigation();
        const getToken = async () => {
            try {
                navigationService.navigation = navigation;
                if (status !== 'succeeded') {
                    await getInfo();
                }
                const accessToken = await storage.getData('accessToken');
                if (accessToken && !customer) {
                    await getCompanyInfo();
                    await getProfile();
                    await getPaymentGateways();
                }
            } catch (error) {
                console.error(error);
                errorHandler(error);
            }
        };

        useEffect(() => {
            getToken();
        }, [navigation]);

        return <Component {...props} />;
    };
};

export default withAuthCheck;
